import { Box } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomTabs from "../../../../global/components/CustomTabs/CustomTabs1";
import { handleErrorMessage } from "../../../../helpers/methods";
import { getPlanetData } from "../../AnalysisService";
import DoshaPada from "./components/DoshaPada";
import ElementPada from "./components/ElementPada";
import Gunas from "./components/Gunas";
import Motivation from "./components/Motivation";
import Orientation from "./components/Orientaion";
import TemperamentPada from "./components/TemperamentPada";
import Trimurti from "./components/Trimurti";

interface CustomProps {
  profileId: string;
  setIsLoading: Function;
}

const Nakshatra = (props: CustomProps) => {
  const { t, i18n } = useTranslation();
  const [tabValue, setTabValue] = useState(`${t("temperamentTab")}`);
  const [data, setData] = useState();

  const tabConfig = [
    {
      label: `${t("temperamentTab")}`,
    },
    {
      label: `${t("elementTab")}`,
    },
    {
      label: `${t("doshaTab")}`,
    },
    {
      label: `${t("trimurtiTab")}`,
    },
    {
      label: `${t("motivationTab")}`,
    },
    {
      label: `${t("orientationTab")}`,
    },
    {
      label: `${t("gunasTab")}`,
    },
  ];

  const planets = [
    { english: "Ascendant", polish: "Ascendent" },
    { english: "Sun", polish: "Słońce" },
    { english: "Moon", polish: "Księżyc" },
    { english: "Mercury", polish: "Merkury" },
    { english: "Venus", polish: "Wenus" },
    { english: "Mars", polish: "Mars" },
    { english: "Jupiter", polish: "Jowisz" },
    { english: "Saturn", polish: "Saturn" },
    { english: "Uranus", polish: "Uran" },
    { english: "Neptune", polish: "Neptun" },
    { english: "Pluto", polish: "Pluton" },
    { english: "Rahu", polish: "Rahu" },
    { english: "Ketu", polish: "Ketu" },
  ];

  // Memoize planet names to update when language changes
  const planetNames = useMemo(() => {
    const currentLanguage = i18n.language.toLowerCase();
    return planets.map((planet) =>
      currentLanguage === "pl" ? planet.polish : planet.english
    );
  }, [i18n.language]);

  useEffect(() => {
    getPlanetsData();
  }, [i18n.language]);

  useEffect(() => {
    setTabValue(`${t("temperamentTab")}`);
  }, [i18n.language]);

  const getPlanetsData = async () => {
    try {
      props.setIsLoading(true);
      const language = i18n.language.toLowerCase();
      const response = await getPlanetData(props?.profileId!, language);
      setData(response.D1.rashiDetails);
      props.setIsLoading(false);
    } catch (error: any) {
      props.setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const handleChange = (newValue: string) => {
    setTabValue(newValue);
  };

  const getComponentBasedOnValue = () => {
    switch (tabValue) {
      case `${t("temperamentTab")}`:
        return <TemperamentPada data={data} planets={planetNames} />;
      case `${t("elementTab")}`:
        return <ElementPada data={data} planets={planetNames} />;
      case `${t("doshaTab")}`:
        return <DoshaPada data={data} planets={planetNames} />;
      case `${t("trimurtiTab")}`:
        return <Trimurti data={data} planets={planetNames} />;
      case `${t("motivationTab")}`:
        return <Motivation data={data} planets={planetNames} />;
      case `${t("orientationTab")}`:
        return <Orientation data={data} planets={planetNames} />;
      case `${t("gunasTab")}`:
        return <Gunas data={data} planets={planetNames} />;
      default:
        return <TemperamentPada data={data} planets={planetNames} />;
    }
  };

  const getNakshatra = () => {
    return (
      <Box pt={2}>
        <CustomTabs
          changeValue={handleChange}
          selected={tabValue}
          tabConfig={tabConfig}
        />
        {data && getComponentBasedOnValue()}
      </Box>
    );
  };

  return getNakshatra();
};

export default Nakshatra;
